import { createElement } from "react";
import { createRoot } from "react-dom/client";
import * as Webfontloader from "webfontloader";

import { App } from "./App";

const loadHtml = () => {
    const baseEl = document.querySelector<HTMLElement>("reviermanager-admin");
    if (!baseEl) return false;

    Webfontloader.load({
        google: {
            families: ["Roboto:300,400,500,700"],
        },
    });

    const root = createRoot(baseEl);
    root.render(createElement(App));
};

if (["interactive", "complete"].includes(document.readyState)) {
    loadHtml();
} else {
    document.addEventListener("DOMContentLoaded", loadHtml, false);
}
